import axios from 'axios';

const leiZruseniZadostiApi = (varsym: string, id: string | number) => {
    return axios({
        method: 'GET',
        url: `LEI/${varsym}/odstranit/${id}`
    });
};

export default leiZruseniZadostiApi;
